/**
 * A SENTENCE THAT HAS TO BE NOTICED
 * =================================
 *
 * Agenda lines are typed by staff, as plain text. Sometimes one sentence in
 * them is the thing a parent must not miss ("Latest pickup is 9pm"), so a
 * line can wrap it in asterisks, `*like this*`, the way anybody would in a
 * text message. Nothing else is markup: an asterisk with no partner stays an
 * asterisk.
 */

export interface Run {
  text: string;
  emphasis: boolean;
}

export function emphasisRuns(text: string): Run[] {
  const runs: Run[] = [];
  const re = /\*([^*\n]+)\*/g;
  let at = 0;
  for (const m of text.matchAll(re)) {
    const start = m.index ?? 0;
    if (start > at) runs.push({ text: text.slice(at, start), emphasis: false });
    runs.push({ text: m[1]!, emphasis: true });
    at = start + m[0].length;
  }
  if (at < text.length) runs.push({ text: text.slice(at), emphasis: false });
  return runs;
}
